import React from 'react'
import { useApolloClient } from '@apollo/client'

import { useIntl } from '@divvy-web/i18n'
import { RemoteModule } from '@divvy-web/utils.dynamic-remotes'
import { error, info, warn } from '@divvy-web/utils.log'

import FederatedSingleSpaApp from '@sputnik/remotes/FederatedSingleSpa'

const loaderFn = () =>
  RemoteModule.import({
    scope: 'bankManager',
    remoteEntryUrl: window.__DivvyEnvironment.REMOTE_BANK_MANAGER_PATH,
    exposedModule: 'MXWidgetParcel',
  })

interface MXWidgetProps {
  isLoadingWidgetUrl: boolean
  isShowing: boolean
  widgetUrl?: string
  widgetUrlError?: Error
  onBankAccountConnected: (bankConnectionId: string, bankUserId: string) => void
  onClose: (result: { connected: boolean }) => void
  onOpenAddManualBankAccount?: () => void
  setIsConnecting?: (value: boolean) => void
  setInstitutionName?: (value: string) => void
}

const MXWidget = (props: MXWidgetProps) => {
  RemoteModule.init({ error, info, squadForLogs: 'vibranium', warn })
  const apolloClient = useApolloClient()
  const intl = useIntl()

  return (
    <FederatedSingleSpaApp
      loaderFn={loaderFn}
      {...{
        ...props,
        renderInsideModal: false,
        apolloClient,
        locale: intl.locale,
      }}
    />
  )
}

export default MXWidget
